module.exports = __webpack_public_path__ + "static/wanlapa.f4917d77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wanlapa.jpg
// module id = 1725
// module chunks = 59246933105914